<template>
    <p class="page-game-instructions__description" v-html="description"></p>
</template>

<script>
export default {
    props: ['description']
}
</script>